import React from "react";
import { getReportStatusConfig } from "./reportStatus";

export const ReportStatusCellRenderer = ({ value }) => {
  if (!value) return null;

  const config = getReportStatusConfig(value);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px 14px",
          borderRadius: "12px",
          backgroundColor: config.bg,
          color: config.text,
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "1",

          whiteSpace: "nowrap",
        }}
      >
        {config.label}
      </span>
    </div>
  );
};
